import PropTypes from 'prop-types';
import { string as stringUtil, constants } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { getAgeTypeLabelForQuantity, getAgeTypeLabel } from '../../../../utils/travelers';
import ReceiptTravelers from './ReceiptTravelers';

const { ageTypes } = constants;

const ReceiptTravelersTextResolver = ({ marketingCarrierNames, travelerPrices = [], ...props }) => {
  const { t } = useTranslation();
  const costPerAgeType = t('Cart.CostPerAgeType');
  const discountPerAgeType = t('Cart.DiscountPerAgeType');
  const pricePerAgeType = t('Cart.PricePerAgeType');
  const taxesAndChargesPerAgeType = t('Cart.TaxesAndChargesPerAgeType');
  const taxesAndChargesPerAgeTypeWithCarriers = t('Cart.TaxesAndChargesPerAgeType.WithCarriers');
  const totalPerAgeType = t('Cart.TotalPerAgeType');
  const totalSumLabel = t('Cart.Total');
  const travelerPricesInfo = travelerPrices.map(({ ageType, taxesAndFees, quantity, ...price }) => {
    const ageTypeLabelForQuantity = t(getAgeTypeLabelForQuantity(ageType, quantity));
    const ageTypeSingularLabel = t(getAgeTypeLabel(ageType)).toLowerCase();

    return {
      ...price,
      ageType,
      ageTypeLabel: stringUtil.insertArgument(ageTypeLabelForQuantity, quantity),
      costLabel: stringUtil.insertArgument(costPerAgeType, ageTypeSingularLabel),
      discountLabel: stringUtil.insertArgument(discountPerAgeType, ageTypeSingularLabel),
      priceLabel: stringUtil.insertArgument(pricePerAgeType, ageTypeSingularLabel),
      taxesAndFees,
      totalLabel: stringUtil.insertArgument(totalPerAgeType, ageTypeSingularLabel),
      vatLabel: marketingCarrierNames
        ? stringUtil.insertArgument(
            taxesAndChargesPerAgeTypeWithCarriers,
            ageTypeSingularLabel,
            marketingCarrierNames,
          )
        : stringUtil.insertArgument(taxesAndChargesPerAgeType, ageTypeSingularLabel),
    };
  });

  return (
    <ReceiptTravelers
      totalSumLabel={totalSumLabel}
      travelerPricesInfo={travelerPricesInfo}
      {...props}
    />
  );
};

ReceiptTravelersTextResolver.propTypes = {
  marketingCarrierNames: PropTypes.string,
  travelerPrices: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.oneOf(Object.values(ageTypes)),
      markup: PropTypes.number,
      price: PropTypes.number,
      quantity: PropTypes.number,
      taxesAndFees: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string,
          taxes: PropTypes.arrayOf(
            PropTypes.shape({
              amount: PropTypes.shape({
                currency: PropTypes.shape,
                value: PropTypes.number,
              }),
              code: PropTypes.string,
              title: PropTypes.string,
            }),
          ),
        }),
      ),
      totalPrice: PropTypes.number,
      totalPriceSum: PropTypes.number,
      vat: PropTypes.number,
    }),
  ),
};
export default ReceiptTravelersTextResolver;
